var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e0"
    },
    d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d9d7ca"
    },
    points: "37.5,0.151 37.5,12 49.349,12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "M 35.67,26.986 C 35.103,26.19 34.37,25.443 33.362,24.635 29.448,21.504 28.605,18.358 28.5,17.897 L 28.5,17 c 0,-0.553 -0.447,-1 -1,-1 -0.553,0 -1,0.447 -1,1 l 0,1 0,8.359 0,9.053 -3.706,0 c -3.882,0 -6.294,1.961 -6.294,5.117 0,3.466 2.24,5.706 5.706,5.706 3.471,0 6.294,-2.823 6.294,-6.294 l 0,-11.473 0.298,0.243 c 0.34,0.336 0.861,0.72 1.521,1.205 2.318,1.709 6.2,4.567 5.224,7.793 C 35.514,37.807 35.5,37.904 35.5,38 c 0,0.43 0.278,0.826 0.71,0.957 0.097,0.029 0.194,0.043 0.29,0.043 0.43,0 0.826,-0.278 0.957,-0.71 C 39.084,32.915 37.035,28.9 35.67,26.986 Z M 26.5,39.941 c 0,2.368 -1.926,4.294 -4.294,4.294 -2.355,0 -3.706,-1.351 -3.706,-3.706 0,-2.576 2.335,-3.117 4.294,-3.117 l 3.706,0 0,2.529 z M 31.505,28.308 C 30.934,27.886 30.44,27.523 30.134,27.227 l -1.634,-1.34 0,-3.473 c 0.827,1.174 1.987,2.483 3.612,3.783 0.858,0.688 1.472,1.308 1.929,1.95 0.716,1.003 1.431,2.339 1.788,3.978 -1.327,-1.61 -3.084,-2.904 -4.324,-3.817 z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.b04cf5e6a58714845cd13d6f21486845.svg";
export { ForwardRef as ReactComponent };